import "./App.css";
import "react-multi-carousel/lib/styles.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React from "react";
import { ConfigProvider } from "antd";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { Login } from "./auth/Login";
import { ForgotPassword } from "./auth/ForgotPassword";
import { Register } from "./auth/Register";
import ResetPassword from "./auth/ResetPassword";
import VerifyUser from "./auth/VerifyUser";
import ErrorBoundary from "./error/ErrorBoundary";
import ErrorPage from "./common/ErrorPage";
import TwoFactor from "./user/component/TwoFactor";

function App() {
  const router = createBrowserRouter([
    {
      path: "",
      element: (
        <ErrorBoundary>
          <Login />
        </ErrorBoundary>
      ),
    },
    {
      path: "register",
      element: (
        <ErrorBoundary>
          <Register />
        </ErrorBoundary>
      ),
    },
    {
      path: "login/two-factor",
      element: (
        <ErrorBoundary>
          <TwoFactor />
        </ErrorBoundary>
      ),
    },
    {
      path: "forgot",
      element: (
        <ErrorBoundary>
          <ForgotPassword />
        </ErrorBoundary>
      ),
    },
    {
      path: "reset-password",
      element: (
        <ErrorBoundary>
          <ResetPassword />
        </ErrorBoundary>
      ),
    },
    {
      path: "onboardify/verify",
      element: (
        <ErrorBoundary>
          <VerifyUser />
        </ErrorBoundary>
      ),
    },
    { path: "*", element: <ErrorPage /> },
  ]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "#497ed8",
            headerColor: "#f0f0f0",
          },
          Card: {
            headerBg: "#497ed8",
          },
          // Checkbox:{
          //   colorPrimary: "#51bc90" ,
          //   colorPrimaryHover: "#51bc90"
          // }
          
        },
      }}
    >
    
        <RouterProvider router={router} />
    
    </ConfigProvider>
  );
}

export default App;
